import ServicesPortal from "./ServicesPortal";

class SubgrupoService extends ServicesPortal {
    constructor(endpoint) {
        super(endpoint);
    }

    getSubgrupos(request) {
        this._url = "/listar";
        return this.get(request);
    }
}

export default new SubgrupoService("subgrupo");